import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { refreshVerification } from './api.js';
import { labelsFor } from './locales.js';

/** Permission/profile access is enforced by the parent core panel and backend. Disabled modules still reconcile history. */
export function DiditActions({ token, history = [], onChanged }) {
  const { i18n } = useTranslation();
  const labels = labelsFor(i18n?.language);
  const [busy, setBusy] = useState(null);
  const [error, setError] = useState('');
  const refresh = async (id) => {
    setBusy(id);
    setError('');
    try {
      await refreshVerification(token, id);
      onChanged?.();
    } catch (failure) { setError(failure.message || 'Could not refresh verification.'); }
    finally { setBusy(null); }
  };
  const attempts = history.filter((item) => item.providerKey === 'didit');
  if (!attempts.length) return null;
  return <div className="d-flex flex-wrap gap-2">
    {error ? <div className="alert alert-danger w-100" role="alert">{error}</div> : null}
    {attempts.map((attempt) => <button key={attempt.id} className="btn btn-sm btn-outline-secondary" disabled={busy !== null} onClick={() => refresh(attempt.id)}>
      {busy === attempt.id ? labels.busy : labels.refresh} <span className="text-muted">({new Date(attempt.createdAt).toLocaleDateString()})</span>
    </button>)}
  </div>;
}
